import PropTypes from 'prop-types'
import { CheckCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { APP_COLORS } from '../../helpers/constants'

const AccessSuccessRoneResidences = ({ onDone }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <div className="package-room__access-container">
        <div className="package-room__icon">
          <CheckCircle size={60} color={APP_COLORS.grayDarkest} weight="regular" />
        </div>

        <h2 className="package-room__title package-room__title--gray">
          {t('package-room:accessSuccessRoneResidences.title')}
        </h2>
        <p className="package-room__subtitle">
          {t('package-room:accessSuccessRoneResidences.subtitle')}
        </p>
      </div>

      <div className="package-room__action-buttons">
        <button className="package-room__submit-button" onClick={onDone}>
          {t('package-room:accessCode.resetAndStartNew')}
        </button>
      </div>
    </div>
  )
}

AccessSuccessRoneResidences.propTypes = {
  onDone: PropTypes.func.isRequired,
  accessCode: PropTypes.string.isRequired,
}

export default AccessSuccessRoneResidences
